import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { Content } from 'src/contexts/ContentContext';
import { DividerLine, Switch } from 'src/core/ui';
import { ContentId } from 'src/utils/constants/contentId';
import {
  Listing,
  ListingDetailsAutoPricingSectionUpdates,
} from 'src/WebApiController';

import { StatLabel } from '../../../Map/StatLabel';
import * as styles from './PricingSetting.css';

export const PricingSettingHeader = ({ listing }: { listing: Listing }) => {
  const { watch, setValue } =
    useFormContext<ListingDetailsAutoPricingSectionUpdates>();
  const { autoPricingEnabled } = watch();

  const sanitizedSeatDisplay = useMemo(() => {
    if (listing.seating?.seatFr === listing.seating?.seatTo) {
      return `${listing.seating?.seatFr}`;
    }
    return `${listing.seating?.seatFr} - ${listing.seating?.seatTo}`;
  }, [listing.seating?.seatFr, listing.seating?.seatTo]);

  return (
    <div className={styles.container}>
      <StatLabel
        stat={listing.seating?.section ?? ''}
        title={<Content id={ContentId.Section} />}
      />
      <DividerLine vertical height={'100%'} />
      <StatLabel
        stat={listing.seating?.row ?? ''}
        title={<Content id={ContentId.Row} />}
      />
      <DividerLine vertical height={'100%'} />
      <StatLabel
        stat={sanitizedSeatDisplay}
        title={<Content id={ContentId.Seats} />}
      />
      <DividerLine vertical height={'100%'} />
      <StatLabel
        stat={`${listing.availQty}`}
        title={<Content id={ContentId.QuantityAbbreviated} />}
      />
      <DividerLine vertical height={'100%'} />
      <Switch
        checked={autoPricingEnabled ?? false}
        onClick={(e) => e.stopPropagation()}
        onCheckedChange={(isChecked) => {
          const checked = isChecked;
          setValue('autoPricingEnabled', checked);
        }}
      />
    </div>
  );
};
